import React from 'react'
import { HighlightEffect } from '../../../enums/KeyboardControls'

interface ControlHighlightProps {
  children: React.ReactElement
  highlightEffect: HighlightEffect
  useSpan?: boolean
  active: boolean
  activeClassName?: string
  className?: string
  [rest: string]: any
};

const defaultClassName = 'accessible-element'

/// By default, the returned element is a div, but with `useSpan=true` a span is returned instead.
/// `activeClassName` is only added if active, `className` is always added.
const ControlHighlight: React.FC<ControlHighlightProps> = ({ children, active, highlightEffect, useSpan = false, activeClassName, className, ...rest }: ControlHighlightProps) => {
  let fullClassName: string | undefined = active
    ? `${highlightEffect} ${activeClassName ?? ''}`
    : ''

  fullClassName = `${defaultClassName} ${fullClassName} ${className ?? ''}`.trim()

  // Undefined if empty to ensure className attr will not be added
  fullClassName = fullClassName.length > 0 ? fullClassName : undefined

  if (useSpan) {
    return (
      <span className={fullClassName} {...rest}>
        {children}
      </span>
    )
  }

  return (
    <div className={fullClassName} {...rest}>
      {children}
    </div>
  )
}

export default ControlHighlight
